import { BlockNoteEditor } from '@blocknote/core';
import { BlockSchema } from '../schema';
import { scaleImagePreviewWidthCssPx } from './commentary-image-layout';

export const applyImageBlockPreviewWidth = (
  editor: BlockNoteEditor<BlockSchema>,
  blockId: string,
  previewWidth: number,
) => {
  const block = editor.getBlock(blockId);
  if (!block || block.type !== 'image' || previewWidth <= 0) {
    return;
  }

  if (block.props.previewWidth === previewWidth) {
    return;
  }

  editor.updateBlock(block, {
    type: 'image',
    props: {
      ...block.props,
      previewWidth,
    },
  });
};

export const applyImageBlockPreviewWidthFromNaturalDimensions = (
  editor: BlockNoteEditor<BlockSchema>,
  blockId: string,
  naturalDimensions: { width: number; height: number },
  maxWidthCssPx?: number,
) => {
  const previewWidth = scaleImagePreviewWidthCssPx(
    naturalDimensions.width,
    naturalDimensions.height,
    maxWidthCssPx,
  );
  applyImageBlockPreviewWidth(editor, blockId, previewWidth);
};
